import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MzBaseModal, MzModalComponent } from "ng2-materialize";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-error-dialog",
  templateUrl: "./agir-error-dialog.component.html",
  styleUrls: ["./agir-error-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AgirErrorDialogComponent extends MzBaseModal implements OnInit {
  env: any = environment;

  constructor() {
    super();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/agir-error-dialog/agir-error-dialog.component.ts